export const handbookArchiveNodes = [
  {
    value: "vii-handbook-archive",
    label: "Previous Handbooks",
    className: "vii-handbook-archive",
  }
]